export const DeliveryTagList = [
  { id: 1, engName: "immediate", korName: "빠른배송" },
  { id: 2, engName: "brand", korName: "브랜드배송" },
];
